<template><section>
<h1>Table 数据表格</h1>
<h2>基本用法</h2>
<demo-block>
                    <div class="source" slot="source"><nt-table :data="tableData" :columns="baseetitle" style="height:200px">


</nt-table></div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-table</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"tableData"</span> <span class="hljs-attr">:columns</span>=<span class="hljs-string">"baseetitle"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"height:200px"</span> /&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">fixedHeadertableData</span>: [
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-04"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1517 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-01"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1519 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-03"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1516 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-23"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1516 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-29"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1516 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        }
      ],
      <span class="hljs-attr">baseetitle</span>: [
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"日期"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"date"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"姓名"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"name"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"省份"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"province"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"市区"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"city"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"地址"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"address"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"邮编"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"zip"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        }
      ]
    };
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h2>固定表头</h2>
<demo-block>
                    <div class="source" slot="source"><nt-table :data="fixedHeadertableData" :columns="baseetitle" style="height:200px">


</nt-table></div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-table</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"fixedHeadertableData"</span> <span class="hljs-attr">:columns</span>=<span class="hljs-string">"baseetitle"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"height:200px"</span> /&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">fixedHeadertableData</span>: [
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-04"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1517 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-01"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1519 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-03"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1516 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-23"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1516 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-29"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1516 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        }
      ],
      <span class="hljs-attr">baseetitle</span>: [
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"日期"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"date"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"姓名"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"name"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"省份"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"province"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"市区"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"city"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"地址"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"address"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"邮编"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"zip"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>
        }
      ]
    };
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h2>固定列</h2>
<demo-block>
                    <div class="source" slot="source"><nt-table :data="fixedColData" :columns="fixColTitle">


</nt-table></div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-table</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"fixedColData"</span> <span class="hljs-attr">:columns</span>=<span class="hljs-string">"fixColTitle"</span>  /&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">fixedColData</span>: [
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-04"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1517 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-01"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1519 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        }
      ],
      <span class="hljs-attr">fixColTitle</span>: [
         {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"日期"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"date"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>,
           <span class="hljs-attr">fixed</span>: <span class="hljs-string">'left'</span>  
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"姓名"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"name"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>,
           <span class="hljs-attr">fixed</span>: <span class="hljs-string">'left'</span>  
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"省份"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"province"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">800</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"市区"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"city"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">800</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"地址"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"address"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">800</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"邮编"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"zip"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">100</span>,     
          <span class="hljs-attr">fixed</span>:<span class="hljs-string">'right'</span>
        }
      ]
    };
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h2>增加操作列</h2>
<demo-block>
                    <div class="source" slot="source"><nt-table :data="fixedColData" :columns="fixColTitle">
    <template v-slot:default="scope" fixed="right">
        <span @click="handleClick(scope.row)">编辑</span>
        <span @click="handleClick(scope.row)">删除</span>
        <span @click="handleClick(scope.row)">编辑</span>
</template>
</nt-table>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-table</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"fixedColData"</span> <span class="hljs-attr">:columns</span>=<span class="hljs-string">"fixColTitle"</span> &gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:default</span>=<span class="hljs-string">"scope"</span> <span class="hljs-attr">fixed</span>=<span class="hljs-string">"right"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleClick(scope.row)"</span>&gt;</span>编辑<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleClick(scope.row)"</span>&gt;</span>删除<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleClick(scope.row)"</span>&gt;</span>编辑<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">nt-table</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">fixedColData</span>: [
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-02"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1518 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-04"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1517 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        },
        {
          <span class="hljs-attr">date</span>: <span class="hljs-string">"2016-05-01"</span>,
          <span class="hljs-attr">name</span>: <span class="hljs-string">"王小虎"</span>,
          <span class="hljs-attr">province</span>: <span class="hljs-string">"上海"</span>,
          <span class="hljs-attr">city</span>: <span class="hljs-string">"普陀区"</span>,
          <span class="hljs-attr">address</span>: <span class="hljs-string">"上海市普陀区金沙江路 1519 弄"</span>,
          <span class="hljs-attr">zip</span>: <span class="hljs-number">200333</span>
        }
      ],
      <span class="hljs-attr">fixColTitle</span>: [
         {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"日期"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"date"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>,
           <span class="hljs-attr">fixed</span>: <span class="hljs-string">'left'</span>  
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"姓名"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"name"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">80</span>,
           <span class="hljs-attr">fixed</span>: <span class="hljs-string">'left'</span>  
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"省份"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"province"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">800</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"市区"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"city"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">800</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"地址"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"address"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">800</span>
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"邮编"</span>,
          <span class="hljs-attr">prop</span>: <span class="hljs-string">"zip"</span>,
          <span class="hljs-attr">width</span>: <span class="hljs-number">100</span>,     
          <span class="hljs-attr">fixed</span>:<span class="hljs-string">'right'</span>
        }
      ]
    };
  },
   handleClick(row){
         <span class="hljs-keyword">this</span>.$dialog({
            <span class="hljs-attr">body</span>:<span class="hljs-built_in">JSON</span>.stringify(row,<span class="hljs-literal">null</span>,<span class="hljs-string">'/t'</span>),
            <span class="hljs-attr">height</span>:<span class="hljs-number">300</span>,
            <span class="hljs-attr">width</span>:<span class="hljs-number">300</span>,
                 <span class="hljs-attr">showMask</span>:<span class="hljs-literal">true</span>,
                 <span class="hljs-attr">justOkBtn</span>:<span class="hljs-literal">true</span>
          })
      }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>data</td>
<td>表格数据</td>
<td>Array</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>columns</td>
<td>表头数据</td>
<td>Array</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>fixed</td>
<td>表头数据</td>
<td>String</td>
<td>right,left,''</td>
<td>false</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {fixedColData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1517 弄",
          zip: 200333 
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1519 弄",
          zip: 200333
        }
      ],
      fixColTitle: [
        {
          label: "日期",
          prop: "date",
          width: 80,
           fixed: 'left'  
        },
        {
          label: "姓名",
          prop: "name",
          width: 80,
           fixed: 'left'  
        },
        {
          label: "省份",
          prop: "province",
          width: 800
        },
        {
          label: "市区",
          prop: "city",
          width: 800
        },
        {
          label: "地址",
          prop: "address",
          width: 800
        },
        {
          label: "邮编",
          prop: "zip",
          width: 100,     
          fixed:'right'
        }
      ],
        fixedHeadertableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1517 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1519 弄",
          zip: 200333
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        },
        {
          date: "2016-05-23",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        },
        {
          date: "2016-05-29",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        }
      ],
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1517 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1519 弄",
          zip: 200333
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        }
      ],
      baseetitle: [
        {
          label: "日期",
          prop: "date",
          width: 80
        },
        {
          label: "姓名",
          prop: "name",
          width: 80
        },
        {
          label: "省份",
          prop: "province",
          width: 80
        },
        {
          label: "市区",
          prop: "city",
          width: 80
        },
        {
          label: "地址",
          prop: "address",
          width: 80
        },
        {
          label: "邮编",
          prop: "zip",
          width: 80
        }
      ],
      title: [
        {
          label: "日期",
          prop: "date",
          width: 85,
          fixed: "left"
        },
        {
          label: "姓名",
          prop: "name",
          width: 292
        },
        {
          label: "省份",
          prop: "province",
          width: 292
        },
        {
          label: "市区",
          prop: "city",
          width: 292
        },
        {
          label: "地址",
          prop: "address",
          width: 292
        },
        {
          label: "邮编",
          prop: "zip",
          width: 292
        }
      ]
    }
  },
      methods:{
      handleClick(row){
         this.$dialog({
            body:JSON.stringify(row,null,'\t'),
            height:300,
            width:400,
                 showMask:true,
                 justOkBtn:true
          })
      }
    }
};
</script>